import cn from 'classnames'

import { useTranslation } from '@mc/i18n'
import { useStaticData } from '@mc/static-data-react'

import { chapterPath } from 'libs/paths'
import Link from 'components/Link'

const ChaptersList = () => {
  const { t } = useTranslation('@mc/next')
  const { chapter, course } = useStaticData()

  return (
    <nav className='mc-theme-dark mc-bg-dark mc-corners--rounded mc-py-5'>
      <h2 className='mc-text--uppercase mc-text--bold mc-text--center mc-mb-3'>
        {t('lesson.details.plan')}
      </h2>
      <ul>
        {course.sortedChapters.map((item) => (
          <li aria-current={chapter.id === item.id} key={item.id}>
            <Link
              className={cn('d-block mc-px-5 mc-py-3', {
                'mc-bg-gray-200 mc-text--bold': chapter.id === item.id,
              })}
              href={chapterPath(course.slug, item.slug)}
              passHref
            >
              {item.number}. {item.title}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  )
}

export default ChaptersList
